// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__8q9ht","name":"NavBar_name__fyGi1"};